/* vr-product.js — the product page section (sections/vr-product.liquid): variant picking from
   the swatch / size radios, add-to-cart into the mini bag, the phone gallery slider and inline
   video. Vanilla ES6, no jQuery (project rule). Re-inits on shopify:section:load.

   The mini bag is opened through window.vrBag, which vr-header.js exports — the same drawer
   Atlantic opens after its own form, fetched the same way. Atlantic only updates the cart badge
   from its own form, so the count is written here from /cart.js. */
(function () {
  'use strict';

  if (window.__vrProduct) return;
  window.__vrProduct = true;

  var routes = (window.Theme && window.Theme.routes) || {};
  var ADD_URL = routes.cart_add_url || '/cart/add';
  var CART_URL = routes.cart_url || '/cart';
  var POSITIONS = ['1', '2', '3'];

  /* "PHP 9,850" — whole amounts drop the centavos, as the Liquid does. */
  function money(cents) {
    var n = cents / 100;
    var whole = Math.abs(n - Math.round(n)) < 0.005;
    return 'PHP ' + n.toLocaleString('en-US', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 });
  }

  function Product(root) {
    this.root = root;
    this.form = root.querySelector('[data-vr-form]');
    this.inputs = Array.prototype.slice.call(root.querySelectorAll('[data-vr-option]'));
    this.idInput = root.querySelector('[data-vr-variant-id]');
    this.addBtn = root.querySelector('[data-vr-add]');
    this.priceNow = root.querySelector('[data-vr-price-now]');
    this.compare = root.querySelector('[data-vr-compare]');
    this.colourName = root.querySelector('[data-vr-colour-name]');
    this.error = root.querySelector('[data-vr-error]');
    var data = root.querySelector('[data-vr-variants]');
    try { this.variants = data ? JSON.parse(data.textContent) : []; } catch (e) { this.variants = []; }

    var self = this;
    this.inputs.forEach(function (input) {
      input.addEventListener('change', function () { self.update(); });
    });
    if (this.form) this.form.addEventListener('submit', function (e) { self.add(e); });

    this.gallery = new Gallery(root);
    root.querySelectorAll('[data-vr-play]').forEach(function (btn) {
      btn.addEventListener('click', function () { playVideo(btn); });
    });
    this.watchApps();
    this.watchSelects();
    this.personalizeState();
    initVideos(root);
  }

  /* Personalize It (the app's button or the theme's link) follows Add To Cart: hidden whenever the
     selected option is sold out (client, issue #9, second round: a sold-out size on a one-colour
     product must hide it too). A class on the root, so it also holds for the app's button, which
     re-renders itself. */
  Product.prototype.personalizeState = function () {
    var v = this.find();
    this.root.classList.toggle('vr-product--no-personalize', this.variants.length > 0 && (!v || !v.available));
  };

  /* The store's Product Personalizer app (Zepto) prepends its own "Personalize It" button to
     the product form on the products it covers. That IS the design's button, so it is moved
     into the actions stack above Add To Cart and the theme's own link is hidden on those
     products; the CSS then dresses it as the outline button. The restock app appends its
     "Notify me" after Add To Cart by itself. Both inject after load, hence the observer.
     The app's PREVIEW label is typed in capitals; it reads "Preview" (client, issue #9). CSS can't
     do it: ::first-letter does not apply to a <button>. */
  Product.prototype.watchApps = function () {
    var self = this;
    var actions = this.root.querySelector('.vr-product__actions');
    if (!this.form || !actions || !window.MutationObserver) return;
    var place = function () {
      var prev = self.form.querySelector('.pplr-preview-btn');
      var label = prev ? prev.textContent.trim() : '';
      if (label.length > 1 && label === label.toUpperCase() && label !== label.toLowerCase()) {
        prev.textContent = label.charAt(0) + label.slice(1).toLowerCase();
      }
      var app = self.form.querySelector('.product-personalizer');
      if (!app || app.closest('.vr-product__actions')) return;
      var wrap = app.parentElement && app.parentElement !== self.form && !app.parentElement.className ? app.parentElement : app;
      wrap.classList.add('vr-product__app-personalize');
      var own = actions.querySelector('[data-vr-personalize]');
      actions.insertBefore(wrap, own || self.addBtn);
      if (own) own.hidden = true;
    };
    place();
    var obs = new MutationObserver(function () { place(); });
    obs.observe(this.form, { childList: true, subtree: true });
  };

  /* The personaliser's Typeface dropdown shows its font list by setting an inline display on
     .pplr-selecter-options (opening, picking a font and clicking outside all do), and marks
     nothing else. The field gets vr-select-open while its list shows, so the caret can turn up
     like the accordion carets (client, issue #9). Watching the style attribute holds whichever
     way the list closes, and the observer also covers lists the app adds later. */
  Product.prototype.watchSelects = function () {
    if (!window.MutationObserver) return;
    var root = this.root;
    var sync = function () {
      root.querySelectorAll('.pplr-selecter-options').forEach(function (list) {
        var field = list.parentElement;
        if (field) field.classList.toggle('vr-select-open', window.getComputedStyle(list).display !== 'none');
      });
    };
    sync();
    new MutationObserver(sync).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
  };

  /* Selected value per option position, from the checked radios. */
  Product.prototype.selected = function () {
    var vals = {};
    this.inputs.forEach(function (input) {
      if (input.checked) vals[input.getAttribute('data-vr-option')] = input.value;
    });
    return vals;
  };

  Product.prototype.matches = function (variant, sel, skipPos) {
    return POSITIONS.every(function (p) {
      if (p === skipPos || !(p in sel)) return true;
      return variant['option' + p] === sel[p];
    });
  };

  Product.prototype.find = function () {
    var sel = this.selected();
    var self = this;
    for (var i = 0; i < this.variants.length; i++) {
      if (self.matches(this.variants[i], sel, null)) return this.variants[i];
    }
    return null;
  };

  Product.prototype.update = function () {
    var sel = this.selected();
    var self = this;

    /* Strike sizes that have no stock under the other chosen options (the colour). */
    this.inputs.forEach(function (input) {
      var pos = input.getAttribute('data-vr-option');
      var label = input.nextElementSibling;
      if (!label || !label.classList.contains('vr-product__size')) return;
      var ok = self.variants.some(function (v) {
        return v.available && v['option' + pos] === input.value && self.matches(v, sel, pos);
      });
      label.classList.toggle('vr-product__size--out', !ok);
    });

    this.personalizeState();
    var v = this.find();
    /* The gallery follows the chosen colour when its photos are tagged by colour (alt text). */
    if (this.gallery && this.root.hasAttribute('data-vr-colour-gallery')) {
      var chosen = this.inputs.filter(function (i) {
        return i.checked && i.nextElementSibling && i.nextElementSibling.classList.contains('vr-product__swatch');
      })[0];
      if (chosen) this.gallery.filter(chosen.value.toLowerCase().trim());
    }
    /* "Color: Grey" follows the checked swatch radio. */
    if (this.colourName) {
      var swatchInput = this.inputs.filter(function (i) {
        return i.checked && i.nextElementSibling && i.nextElementSibling.classList.contains('vr-product__swatch');
      })[0];
      if (swatchInput) this.colourName.textContent = swatchInput.value;
    }

    if (!v) {
      this.setButton(false, this.addBtn.getAttribute('data-label-out'));
      return;
    }
    this.idInput.value = v.id;
    if (this.priceNow) this.priceNow.textContent = money(v.price);
    if (this.compare) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        this.compare.textContent = money(v.compare_at_price);
        this.compare.hidden = false;
      } else {
        this.compare.hidden = true;
      }
    }
    this.setButton(v.available, v.available ? this.addBtn.getAttribute('data-label-add') : this.addBtn.getAttribute('data-label-out'));
    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    /* Phones: show the variant's own photo. */
    /* A colour-filtered gallery already starts on that colour's first photo; otherwise jump to it. */
    if (v.featured_media && this.gallery && !this.root.hasAttribute('data-vr-colour-gallery')) this.gallery.show(v.featured_media.id);
    this.hideError();
  };

  Product.prototype.setButton = function (enabled, label) {
    if (!this.addBtn) return;
    this.addBtn.disabled = !enabled;
    if (label) this.addBtn.textContent = label;
  };

  Product.prototype.showError = function (msg) {
    if (!this.error) return;
    this.error.textContent = msg;
    this.error.hidden = false;
  };
  Product.prototype.hideError = function () { if (this.error) this.error.hidden = true; };

  Product.prototype.add = function (e) {
    if (!window.fetch || !window.FormData) return;          /* plain POST to /cart/add */
    e.preventDefault();
    if (!this.addBtn || this.addBtn.disabled) return;
    var self = this;
    var restoreLabel = this.addBtn.textContent;
    this.setButton(false, this.addBtn.getAttribute('data-label-adding'));
    this.hideError();

    var body = new FormData();
    body.append('id', this.idInput.value);
    body.append('quantity', '1');
    /* Line-item properties from any app that injected them into the form. */
    if (this.form) {
      new FormData(this.form).forEach(function (value, key) {
        if (key.indexOf('properties[') === 0 || key === 'selling_plan') body.append(key, value);
      });
    }

    fetch(ADD_URL + '.js', {
      method: 'POST', body: body, credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.json.description || res.json.message || 'Could not add to bag.');
        return fetch(CART_URL + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-mini-count]').forEach(function (el) {
          el.textContent = cart.item_count === 0 ? '' : String(cart.item_count);
        });
        if (window.vrBag && typeof window.vrBag.open === 'function') {
          window.vrBag.open(self.addBtn);
        } else {
          window.location.href = CART_URL;
        }
      })
      .catch(function (err) { self.showError(err.message || 'Could not add to bag.'); })
      .then(function () { self.setButton(true, restoreLabel); });
  };

  /* Phone gallery: an overflow scroller with snap; arrows step one slide, the bar shows the
     position. On desktop the track is a grid and the controls are display:none. */
  function Gallery(root) {
    this.track = root.querySelector('[data-vr-gallery-track]');
    /* `all` is every tile; `cells` only the visible ones (another colour's photos are hidden). */
    this.all = this.track ? Array.prototype.slice.call(this.track.querySelectorAll('[data-vr-gallery-cell]')) : [];
    this.cells = this.all.filter(function (c) { return !c.hidden; });
    this.prev = root.querySelector('[data-vr-gallery-prev]');
    this.next = root.querySelector('[data-vr-gallery-next]');
    this.bar = root.querySelector('[data-vr-gallery-bar]');
    if (!this.track || this.all.length < 2) return;
    var self = this;
    if (this.prev) this.prev.addEventListener('click', function () { self.step(-1); });
    if (this.next) this.next.addEventListener('click', function () { self.step(1); });
    var raf = null;
    this.track.addEventListener('scroll', function () {
      if (raf) return;
      raf = window.requestAnimationFrame(function () { raf = null; self.render(); });
    }, { passive: true });
    window.addEventListener('resize', function () { self.render(); });
    this.render();
  }

  /* Show one colour's photos (plus the shared ones) and start again from the first. */
  Gallery.prototype.filter = function (colourKey) {
    if (!this.track) return;
    this.all.forEach(function (c) {
      var tag = c.getAttribute('data-vr-media-colour') || '';
      c.hidden = !!tag && tag !== colourKey;
    });
    this.cells = this.all.filter(function (c) { return !c.hidden; });
    var few = this.cells.length < 2;
    if (this.prev) this.prev.hidden = few;
    if (this.next) this.next.hidden = few;
    if (this.bar && this.bar.parentNode) this.bar.parentNode.hidden = few;
    this.track.scrollLeft = 0;
    if (this.cells.length) this.render();
  };

  Gallery.prototype.stepSize = function () {
    if (this.cells.length > 1) return this.cells[1].offsetLeft - this.cells[0].offsetLeft;
    return this.track.clientWidth;
  };

  Gallery.prototype.step = function (dir) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.track.scrollBy({ left: this.stepSize() * dir, behavior: reduce ? 'auto' : 'smooth' });
  };

  Gallery.prototype.show = function (mediaId) {
    if (!this.track || this.track.scrollWidth <= this.track.clientWidth) return;
    var cell = this.cells.filter(function (c) { return String(c.getAttribute('data-media-id')) === String(mediaId); })[0];
    if (cell) this.track.scrollTo({ left: cell.offsetLeft - this.cells[0].offsetLeft, behavior: 'auto' });
  };

  Gallery.prototype.render = function () {
    if (!this.track || !this.cells.length) return;
    var max = this.track.scrollWidth - this.track.clientWidth;
    var x = this.track.scrollLeft;
    if (this.prev) this.prev.disabled = x <= 1;
    if (this.next) this.next.disabled = x >= max - 1;
    if (this.bar && this.bar.parentNode) {
      var trackW = this.bar.parentNode.clientWidth;
      var inkW = Math.max(24, trackW / this.cells.length);
      this.bar.style.width = inkW + 'px';
      var t = max > 0 ? (x / max) * (trackW - inkW) : 0;
      this.bar.style.transform = 'translateX(' + t + 'px)';
    }
  };

  /* Gallery videos autoplay muted (markup). Visitors who ask for reduced motion get them paused
     with the play button instead, and every video pauses while off screen. */
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function initVideos(root) {
    root.querySelectorAll('[data-vr-video] video').forEach(function (video) {
      var tile = video.closest('[data-vr-video]');
      video.muted = true;
      if (REDUCED) { video.autoplay = false; video.pause(); return; }
      tile.classList.add('is-playing');
      if (!window.IntersectionObserver) return;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
          else video.pause();
        });
      }, { threshold: 0.25 }).observe(tile);
    });
  }

  function playVideo(btn) {
    var tile = btn.closest('[data-vr-video]');
    var video = tile ? tile.querySelector('video') : null;
    if (!video) return;
    video.controls = true;
    tile.classList.add('is-playing');
    var p = video.play();
    if (p && p.catch) p.catch(function () { video.controls = true; });
  }

  /* Sticky details column (the section's "sticky" setting; fallback CSS in vr-product.css).
     A column that fits under the header just parks there. A taller one tracks a target top `y`
     that follows the page and is held between two bounds: `ub` (top under the header) and
     `lb` (bottom 24 above the screen edge). So scrolling down it rides the page until its end is
     in view and holds; scrolling up it rides back until its top is under the header.
     Rendering keeps scrolling on the compositor: at a bound the column is `sticky` with that
     top (the browser holds it, and still stops it where the gallery ends); between bounds it is
     `relative` with a fixed offset, so it moves with the page natively. JS only changes the
     mode at the bounds.
     Height changes (an accordion opening) keep `y`, so the clicked row does not jump; if the
     column has to move anyway (it outgrew the gallery), the page is scrolled by the same
     amount so the clicked row stays put. Desktop only: at 999 and below the columns stack. */
  var STICK_GAP = 24;
  function stick(root) {
    if (!root.classList.contains('vr-product--sticky')) return;
    var info = root.querySelector('.vr-product__info');
    if (!info) return;
    var stacked = window.matchMedia('(max-width: 999px)');
    var y = null;
    var lastScroll = window.pageYOffset;
    var padT = 0, padB = 0;
    var yBeforeToggle = null;

    function measurePad() {
      var cs = window.getComputedStyle(root);
      padT = parseFloat(cs.paddingTop) || 0;
      padB = parseFloat(cs.paddingBottom) || 0;
    }
    function clear() {
      y = null;
      info.style.position = '';
      info.style.top = '';
    }
    function render(dy) {
      if (stacked.matches) { clear(); return; }
      var header = document.querySelector('.vr-header[data-sticky="true"]');
      var rect = root.getBoundingClientRect();
      var cTop = rect.top + padT;                        /* where the column sits unmoved */
      var h = info.offsetHeight;
      var cMax = rect.bottom - padB - h;                 /* lowest top before it leaves the row */
      var ub = (header ? header.offsetHeight : 0) + STICK_GAP;
      var lb = Math.min(ub, window.innerHeight - h - STICK_GAP);
      var yb;
      var stuck;
      if (y === null) {
        yb = Math.max(lb, Math.min(ub, cTop));
        stuck = yb === lb || yb === ub;
      } else {
        /* Never pull toward a bound the column has already passed (after an accordion closes
           its bottom can sit above lb): hold instead, and let the page catch up. */
        var lo = Math.min(lb, y);
        yb = Math.max(lo, Math.min(ub, y - dy));
        stuck = yb === lo || yb === ub;
      }
      y = Math.max(cTop, Math.min(yb, cMax));
      if (stuck) {
        info.style.position = 'sticky';
        info.style.top = yb + 'px';
      } else {
        info.style.position = 'relative';
        info.style.top = (y - cTop) + 'px';
      }
    }

    measurePad();
    render(0);
    window.addEventListener('scroll', function () {
      var now = window.pageYOffset;
      var dy = now - lastScroll;
      lastScroll = now;
      render(dy);
    }, { passive: true });
    window.addEventListener('resize', function () { measurePad(); render(0); });
    if (stacked.addEventListener) stacked.addEventListener('change', function () { clear(); render(0); });
    if (window.ResizeObserver) new ResizeObserver(function () { render(0); }).observe(info);

    /* Keep the clicked accordion row where it was. */
    info.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('summary')) yBeforeToggle = y;
    }, true);
    info.addEventListener('toggle', function () {
      render(0);
      if (yBeforeToggle !== null && y !== null && Math.abs(y - yBeforeToggle) > 1) {
        window.scrollBy(0, y - yBeforeToggle);
      }
      yBeforeToggle = null;
    }, true);
  }

  /* The Restock Alerts popup's button reads "Notify Me When Available" (the app's label); the site
     writes buttons in sentence case (client, issue #9). The app builds the popup on each open and
     re-renders it on every keystroke, so a page-wide observer fixes the label whenever it appears.
     The app's OWN text node is edited in place: replacing it (textContent = …) detached the node
     the app renders into, and the app then added a fresh copy on every keystroke — "Notify me when
     availablenotify me when available…" (issue #9, 2026-10-05). Text already in sentence case is
     left alone, so the observer never loops. */
  function sentenceCase(label) {
    return label.charAt(0).toUpperCase() + label.slice(1).toLowerCase();
  }
  function fixRestockButton() {
    document.querySelectorAll('.restock-alerts-submit-button').forEach(function (btn) {
      if (btn.childElementCount) return;
      Array.prototype.forEach.call(btn.childNodes, function (node) {
        if (node.nodeType !== 3) return;
        var label = node.nodeValue.trim();
        if (label && label !== sentenceCase(label)) node.nodeValue = node.nodeValue.replace(label, sentenceCase(label));
      });
    });
  }
  if (window.MutationObserver && document.querySelector('[data-vr-product]')) {
    fixRestockButton();
    new MutationObserver(fixRestockButton).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-vr-product]').forEach(function (root) {
      if (root.__vrProduct) return;
      root.__vrProduct = new Product(root);
      stick(root);
    });
  }

  /* Theme editor */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    /* Open the accordion being edited. */
    var block = e.target;
    if (block && block.tagName === 'DETAILS' && block.classList.contains('vr-product__acc')) block.open = true;
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
})();
